export const textColors = [
  { value: '#1794c1', name: 'Blue' },
  { value: '#006400', name: 'Green' },
  { value: '#ff6600', name: 'Orange' },
]
